import React, { useMemo, useState } from 'react'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import { Accordion } from '@tecuity/granite-ui/Accordion'
import { DetailList } from '@tecuity/granite-ui/DetailList'
import { format } from 'date-fns'
import { useDispatch, shallowEqual, useSelector } from 'react-redux'
import { openSpecificImage } from '../../ImageViewer/ImageViewerActions'
import { checkDLNValid } from '../../BOSearch/BOSearchActions'
import { setErrorToast } from '../../../actions'
import { SET_SELECTED_NOTARY_COMPLAINT } from '../RecordDetailsReducer'

const getDlnLink = (dln, dispatch) => {
  if (dln) {
    return (
      <div
        className={dln.indexOf(',') === -1 ? 'dlnTableLink' : ''}
        tabIndex={dln.indexOf(',') === -1 ? 0 : -1}
        onClick={() => {
          return dln.indexOf(',') === -1
            ? checkDLNValid(
                dln,
                (id) => {
                  dispatch(openSpecificImage(id, dln))
                },
                (dln) => {
                  dispatch(setErrorToast('DLN ' + dln + ' not found'))
                }
              )
            : null
        }}
      >
        {dln}
      </div>
    )
  } else {
    return ''
  }
}

const NotaryComplaintsPanel = ({ setShowDrawer }) => {
  const dispatch = useDispatch()
  const { NotaryComplaints = [] } = useSelector((state) => state.record.recordDetails, shallowEqual)

  const columns = [
    {
      field: 'displayNotaryComplaintType',
      headerName: 'Complaint Type',
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => params.row.NotaryComplaintType.Name,
    },
    {
      field: 'FilingDate',
      headerName: 'Filing Date',
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        return format(new Date(params.row.FilingDate), 'MM/dd/yyyy')
      },
    },
    {
      field: 'displayNotaryComplaintStatusType',
      headerName: 'Status',
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => params.row.NotaryComplaintStatusType.Name,
    },
    {
      field: 'DLNNum',
      headerName: 'DLN',
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        const dln = params.row.DLNNum
        return getDlnLink(dln, dispatch)
      },
    },
  ]

  return (
    <React.Fragment>
      <h2>Complaints</h2>
      <GraniteDataGrid
        getRowId={(r) => r.NotaryComplaintId}
        rows={NotaryComplaints}
        columns={columns}
        isRowSelectable={(params) => {
          return true
        }}
        rowHeight={60}
        rowBuffer={0}
        onRowClick={(params) => {
          setShowDrawer(true)
          dispatch({ type: SET_SELECTED_NOTARY_COMPLAINT, selectedNotaryComplaint: params.row })
        }}
      />
    </React.Fragment>
  )
}

export default NotaryComplaintsPanel

export const ComplaintDetail = () => {
  const dispatch = useDispatch()
  const { selectedNotaryComplaint } = useSelector((state) => state.record, shallowEqual)
  const [showComplaintDetails, setShowComplaintDetails] = useState(true)
  const [showReasons, setShowReasons] = useState(true)

  const details = useMemo(() => {
    const array = []
    array.push({
      label: 'Complaint Type',
      value: selectedNotaryComplaint.NotaryComplaintType.Name,
    })
    array.push({
      label: 'Filing Date',
      value: format(new Date(selectedNotaryComplaint.FilingDate), 'MM/dd/yyyy'),
    })
    array.push({ label: 'Status', value: selectedNotaryComplaint.NotaryComplaintStatusType.Name })
    array.push({ label: 'DLN #', value: getDlnLink(selectedNotaryComplaint.DLNNum, dispatch) })

    return array
  }, [selectedNotaryComplaint])

  return (
    <div>
      <Accordion
        title="Complaint Details"
        isOpen={showComplaintDetails}
        onChange={() => {
          setShowComplaintDetails((isOpen) => !isOpen)
        }}
      >
        <DetailList details={details} bottomBorder />
      </Accordion>
      <Accordion
        title="Reasons"
        isOpen={showReasons}
        onChange={() => {
          setShowReasons((isOpen) => !isOpen)
        }}
      >
        {(selectedNotaryComplaint.NotaryComplaintReasonXrefs || []).map((reason) => {
          const type = reason.NotaryComplaintReasonType
          const description = type.Description.includes('[PARAM1]')
            ? type.Description.replace('[PARAM1]', reason.Params)
            : type.Description
          return (
            <div key={reason.NotaryComplaintId} className="reason-list">
              <div className="reason-name">{type.Name}:</div>
              <div className="reason-description">{description}</div>
            </div>
          )
        })}
      </Accordion>
    </div>
  )
}
